// URL namespacing – izolace parametrů vrstev v search params
// Formát: l{layerIndex}_{paramName} = hodnota

const LAYER_PREFIX = 'l';
const SEPARATOR = '_';

/** Vytvoří prefixovaný klíč pro search param dané vrstvy */
export function namespacedKey(layerIndex: number, paramName: string): string {
  return `${LAYER_PREFIX}${layerIndex}${SEPARATOR}${paramName}`;
}

/** Parsuje prefixovaný klíč zpět na [layerIndex, paramName] */
export function parseNamespacedKey(key: string): { layerIndex: number; paramName: string } | null {
  const match = /^l(\d+)_(.+)$/.exec(key);
  if (!match?.[1] || !match[2]) return null;
  return { layerIndex: Number(match[1]), paramName: match[2] };
}

/** Rezervované meta-klíče pro identitu vrstvy */
export const META_KEYS = {
  AGENDA_ID: 'aid',
  PRESENTATION: 'pres',
  /** Identita floating stacku (skupiny osamostatněných oken). Plocha = bez tohoto klíče. */
  STACK_ID: 'sid',
} as const;

/** Vytvoří meta klíč pro danou vrstvu */
export function metaKey(layerIndex: number, metaName: string): string {
  return namespacedKey(layerIndex, `__${metaName}`);
}

/** Parsuje meta klíč */
export function parseMetaKey(key: string): { layerIndex: number; metaName: string } | null {
  const parsed = parseNamespacedKey(key);
  if (!parsed) return null;
  if (!parsed.paramName.startsWith('__')) return null;
  return { layerIndex: parsed.layerIndex, metaName: parsed.paramName.slice(2) };
}
